import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // كل بيانات المستخدم
  const [subscriptionActive, setSubscriptionActive] = useState(false); // حالة الاشتراك
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // قراءة المستخدم و token من localStorage عند البداية
    const storedUser = localStorage.getItem("user");
    const storedToken = localStorage.getItem("token");

    if (storedUser && storedToken) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);

      // 🔹 استخراج حالة الاشتراك
      setSubscriptionActive(Boolean(parsedUser.subscription_active));
    } else {
      setUser(null);
      setSubscriptionActive(false);
    }

    setLoading(false); // انتهى التحميل
  }, []);

  // 🔹 وظيفة لتحديث الاشتراك إذا تغير (مثلاً بعد تجديد الاشتراك)
  const updateSubscription = (status) => {
    setSubscriptionActive(status);
    if (user) {
      setUser({ ...user, subscription_active: status });
      localStorage.setItem(
        "user",
        JSON.stringify({ ...user, subscription_active: status })
      );
    }
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, subscriptionActive, updateSubscription, loading }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
